import * as React from 'react';

export function PublicLayout({ children }) {
    return (
        <div>
            <main>
                {children}
            </main>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/layouts/PublicLayout.js